export default __webpack_public_path__ + "static/media/templates.f3cf7724.svg";